export const ANONYMOUS_ID_PREFIX = 'anonymous';
export const NICKNAME_MIN_LENGTH = 3;
export const NICKNAME_MAX_LENGTH = 15;
export const TIME_TRIGGER_FOR_GROUPING_MESSAGES_IN_MS = 50000;
export const PROSODY_TIMEOUT_ON_NICKNAME_CHANGE_REQUEST_IN_MS = 10000;
